<template>
	<div class="login-content">
		<div class="login-tit">
			<p @click="goBack()">登录 ></p>
			<p class="on-p"> 忘记密码</p>
		</div>
		<div class="login">
			<h1>重置密码</h1>

			<section class="passDiv">
				<article class="pass_ul flex zhong float">
					<div class="passTxt on">验证身份</div>
					<img src="../../image/login_go-a.png" />
					<div
						class="passTxt passTxta"
						:class="isTwo != 1 ? 'on' : ''"
					>设置新密码</div>
					<img src="../../image/login_go-a.png" />
					<div
						class="passTxt passTxtb"
						:class="isTwo == 3 ? 'on' : ''"
					>重置成功</div>
				</article>
			</section>

			<section
				class="login_nei"
				v-if="isTwo == 1"
			>
				<form action="">
					<div class="login_input flex zhong ">
						<img src="../../image/login_a.png" />
						<input
							type="text"
							placeholder="请输入手机号"
							v-model.trim="model.Phone"
						/>
					</div>

					<div class="login_input flex zhong ">
						<img src="../../image/login_b.png" />
						<input
							type="number"
							placeholder="请输入短信验证码"
							v-model.number="code"
						/>
						<button
							class=" sendCode"
							@click="sendMessage"
							type="button"
						>{{ btnText }}</button>
					</div>
					<el-button
						type="primary"
						class="btn"
						@click="downClick()"
					>下一步</el-button>
				</form>
			</section>

			<section
				class="login_nei"
				v-else-if="isTwo == 2"
			>
				<form action="">
					<div class="login_input flex zhong ">
						<img src="../../image/login_b.png" />
						<input
							type="password"
							placeholder="设置6至20位登录密码"
							v-model="model.Password"
						/>
					</div>
					<div class="login_input flex zhong ">
						<img src="../../image/login_b.png" />
						<input
							type="password"
							placeholder="请再次输入登录密码"
							v-model="passwordConfirm"
						/>
					</div>
					<el-button
						type="primary"
						class="btn"
						@click="cgClick()"
					>下一步</el-button>
				</form>
			</section>

			<section
				class="login_nei last_box"
				v-else-if="isTwo == 3"
			>
				<img src="../../image/login_ok.png" />
				<h6>重置成功</h6>
				<p>请妥善保管您的账户信息</p>
				<button
					type="button"
					@click="goLogin()"
				>重新登录</button>
			</section>
		</div>
	</div>
</template>
<script>
export default {
    name: 'login',
    data() {
        return {
            isTwo: 1,
            btnDisabled: false,
            btnText: '获取验证码',
            code: '',
            model: {
                Phone: '',
                Password: ''
            },
            passwordConfirm: '',
            downCount: 60
        };
    },
    methods: {
		// 返回
		goBack() {
			this.$router.go(-1);
		},
        // 下一步 1=> 2
        downClick() {
            if (!this.model.Phone) {
                this.$util.showError('请输入手机号');
                return;
            }
            if (!this.$util.validatePhone(this.model.Phone)) {
                this.$util.showError('请输入合法手机号');
                return;
            }
            if (!this.code) {
                this.$util.showError('请输入验证码');
                return;
            }
            this.$api.verifyCode({ phone: this.model.Phone, code: this.code }).then(res => {
                this.isTwo = 2;
            }).catch(err => {
                console.log('downClick -> err', err);
            });
        },
        // 下一步 2=>3
        cgClick() {
            if (!this.model.Phone) {
                this.$util.showError('请输入手机号');
                return;
            }
            if (!this.$util.validatePhone(this.model.Phone)) {
                this.$util.showError('请输入合法手机号');
                return;
            }
            if (!this.model.Password) {
                this.$util.showError('请输入密码');
                return;
            }
            if (!this.passwordConfirm) {
                this.$util.showError('请再次输入密码');
                return;
            }
            if (this.model.Password.length < 6 || this.model.Password.length > 20) {
                this.$util.showError('密码长度为6-20位');
                return;
            }
            if (this.passwordConfirm !== this.model.Password) {
                this.$util.showError('两次密码输入不一致');
                return;
            }
            this.$api.resetPassword(this.model).then(res => {
                this.$store.dispatch('user/logout');
                this.isTwo = 3;
            });
        },
        // 登录
        goLogin() {
            this.$router.push('/login');
        },
        // 倒计时
        sendMessage() {
            if (this.btnDisabled) {
                return;
            }
            if (!this.model.Phone) {
                this.$util.showError('请输入手机号');
                return;
            }
            if (!this.$util.validatePhone(this.model.Phone)) {
                this.$util.showError('请输入合法手机号');
                return;
            }
            this.btnDisabled = true;
            this.$api.getPhoneCode({ phone: this.model.Phone, type: 2 }).then(res => {
                this.$util.showMsg(res.code === 0, res.msg);
                if (res.code === 0) {
                    this.timer = setInterval(() => {
                        this.btnText = '重新获取(' + this.downCount + 's)';
                        this.downCount--;
                        if (this.downCount <= 0) {
                            this.btnText = '获取验证码';
                            this.downCount = 60;
                            this.btnDisabled = false;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            }).catch(err => {
                console.log('sendMessage -> err', err);
                this.btnDisabled = false;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.last_box button {
    font-size: 14px;
    color: #333;
    border-radius: 4px;
    border: solid 1px #333;
    text-align: center;
    display: block;
    width: 200px;
    height: 40px;
    margin: 30px auto 0 auto;
    line-height: 40px;
    cursor: pointer;
}

.last_box p {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 10px;
}

.last_box h6 {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-top: 20px;
}

.last_box img {
    display: block;
    width: 80px;
    height: 80px;
    margin: 0 auto;
}

.last_box {
    padding-bottom: 60px;
}

/*last_box*/

.pass_ul img {
    display: block;
    width: 20px;
    height: 20px;
}

.passTxt {
    width: 120px;
    height: 40px;
    position: relative;
    overflow: visible;
    border-radius: 4px;
    border: solid 1px #7a7e80;
    text-align: center;
    font-size: 14px;
    color: #7a7e80;
    line-height: 40px;
}

.passTxta::before {
    content: '2' !important;
}

.passTxtb::before {
    content: '3' !important;
}

.passTxt.on {
    border-color: #333;
    color: #333;
}

.passTxt.on::before {
    color: #333;
}

.passTxt.on::after {
    background-color: #333;
}

.passTxt::before {
    content: '1';
    font-size: 18px;
    color: #7a7e80;
    font-weight: 600;
    position: absolute;
    left: 6px;
    top: -22px;
    z-index: 1;
    background-color: #eaeaea;
    width: 20px;
    text-align: center;
}

.passTxt::after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #7a7e80;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
}

.pass_ul {
    overflow: visible;
    width: 560px;
    margin: 0 auto;
}

.passDiv {
    overflow: hidden;
    background-color: #eaeaea;
    padding: 20px 0;
}

/*passDiv*/

.btn {
    display: block;
    width: 100%;
    background-color: #333;
    border-color: #333;
    cursor: pointer;
}

.login_box p {
    font-size: 14px;
    margin-left: 0.5em;
}

.login_box {
    margin-bottom: 30px;
}

/*login_box*/

.login_input input::-webkit-input-placeholder {
    color: #999;
}
.login_input input:-moz-placeholder {
    color: #999;
}
.login_input input:-ms-input-placeholder {
    color: #999;
}

.login_input input {
    overflow: hidden;
    width: calc(100% - 30px);
    padding-left: 10px;
    font-size: 14px;
    color: #333;
    display: block;
    height: 100%;
}

.login_input img {
    display: block;
    width: 20px;
    height: 20px;
}

.login_input {
    margin-bottom: 20px;
    overflow: hidden;
    border-radius: 4px;
    height: 40px;
    border: solid 1px #06222c;
    padding: 0 10px;
    width: 100%;
    box-sizing: border-box;
}

.login_nei {
    overflow: hidden;
    width: 340px;
    margin: 60px auto 0 auto;
}

/*login_nei*/

.login h1::after {
    content: '';
    width: 160px;
    height: 6px;
    background-color: #333;
    position: absolute;
    left: 50%;
    margin-left: -80px;
    bottom: 0;
    z-index: 1;
}

.login h1 {
    padding: 10px 0 30px 0;
    overflow: hidden;
    border-bottom: solid 2px #333;
    font-size: 18px;
    color: #333;
    text-align: center;
    position: relative;
}

.login {
    overflow: hidden;
    width: 100%;
    margin: 20px auto;
    padding: 20px;
	height: auto;
	background-color: #fff;
}
.login-content{
	overflow: hidden;
	width: 1200px;
	margin: 0 auto;
	padding: 20px;
	min-height: 50vh;
}
.login-tit{
	width: 100%;
	display: flex;
	align-items: center;
}
.login-tit p{
	font-size: 15px;
	color: #666;
	cursor: pointer;
	padding-right: 10px;
}
.login-tit .on-p{
	color: #333;
}

.sendCode {
    overflow: hidden;
    width: 180px;
    font-size: 14px;
    color: #333;
    position: relative;
    text-align: center;
    cursor: pointer;
}

.sendCode::after {
    content: '';
    width: 2px;
    height: 14px;
    background-color: #333;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -7px;
    z-index: 1;
}

/*sendCode*/
</style>
